module.exports = __webpack_public_path__ + "static/media/axe.156cf143.png";